module.exports = __webpack_public_path__ + "img/scan-active.9df0e547.svg";